module.exports = __webpack_public_path__ + "static/img/star-reward.b3a3d1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/star-reward.jpg
// module id = N7+D
// module chunks = 1